var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialNetworkIconWebsite = function SvgSocialNetworkIconWebsite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 16 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,0h-15C0.224,0,0,0.224,0,0.5v10C0,10.776,0.224,11,0.5,11h5.7l-0.926,2.314C5.143,13.643,5.385,14,5.739,14h4.52c0.354,0,0.596-0.359,0.464-0.687L9.788,11H15.5c0.276,0,0.5-0.224,0.5-0.5v-10C16,0.224,15.776,0,15.5,0z M14,9.035H8.979H7H2v-7h12V9.035z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialNetworkIconWebsite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ae7254737220c3abcf0735a875a82018.svg";